import { IInvoiceResponse } from "@miplatform/types";
import { formatDate, getCurrencyString } from "@miplatform/utils";

export const OPEN_INVOICES_TAB = "open-payments" as const;
export const PAID_INVOICES_TAB = "paid-invoices" as const;

export type TabValue = typeof OPEN_INVOICES_TAB | typeof PAID_INVOICES_TAB;

interface Tab {
  label: string;
  value: TabValue;
}

export interface Field {
  label: string;
  fieldKey: string;
  width?: number;
  type?: "date" | "currency" | "string";
}

export const tabs: Tab[] = [
  { label: "Open Invoices", value: OPEN_INVOICES_TAB },
  { label: "Paid Invoices", value: PAID_INVOICES_TAB },
];

export const FIELD_WIDTH = 120;

interface ListConfigItem {
  fields: Field[];
  getGroupedTitle?: (title: string, data?: IInvoiceResponse[]) => string;
  getGroupedCriteria?: ((item: IInvoiceResponse) => string) | string;
}

export function getListConfig(filters: {
  groupBy: string;
}): Record<TabValue, ListConfigItem> {
  return {
    [OPEN_INVOICES_TAB]: {
      fields: [
        { label: "Invoice Name", fieldKey: "name" },
        { label: "Invoice #", fieldKey: "invoiceNumber" },
        { label: "Invoice Date", fieldKey: "invoicedDate", type: "date" },
        { label: "Original Amt", fieldKey: "totalAmount", type: "currency" },
        { label: "Amt. Due", fieldKey: "amountDue", type: "currency" },
      ],
      getGroupedTitle: (title: string, data?: IInvoiceResponse[]) => {
        if (filters.groupBy === "invoicedDate") {
          return `Invoiced Date: ${formatDate(
            title ?? "",
            "dddd, MMMM D, YYYY"
          )} / ${getCurrencyString(
            (data ?? []).reduce((acc, item) => acc + (item.amountDue || 0), 0)
          )}`;
        }
        if (filters.groupBy === "billToAccountId") {
          return `${
            data?.[0]?.billToAccount?.name || "Unknown Customer"
          }: ${getCurrencyString(
            (data ?? []).reduce((acc, item) => acc + (item.amountDue || 0), 0)
          )}`;
        }
        return "";
      },
      getGroupedCriteria: filters.groupBy
        ? (item) => {
            if (filters.groupBy === "invoicedDate") {
              return formatDate(item.invoicedDate, "DD MMMM YYYY") || "";
            }
            if (filters.groupBy === "billToAccountId") {
              return item.billToAccountId || "";
            }
            return "";
          }
        : undefined,
    },
    [PAID_INVOICES_TAB]: {
      fields: [
        { label: "Invoice Name", fieldKey: "name" },
        { label: "Invoice #", fieldKey: "invoiceNumber" },
        { label: "Invoice Date", fieldKey: "invoicedDate" },
        { label: "Original Amt", fieldKey: "totalAmount", type: "currency" },
        { label: "Amt. Due", fieldKey: "amountDue", type: "currency" },
      ],
      getGroupedTitle: (title: string, data?: IInvoiceResponse[]) => {
        if (filters.groupBy === "invoicedDate") {
          return `Invoiced Date: ${formatDate(
            title ?? "",
            "dddd, MMMM D, YYYY"
          )} / ${getCurrencyString(
            (data ?? []).reduce((acc, item) => acc + (item.amountDue || 0), 0)
          )}`;
        }
        if (filters.groupBy === "billToAccountId") {
          return `${
            data?.[0]?.billToAccount?.name || "Unknown Customer"
          }: ${getCurrencyString(
            (data ?? []).reduce((acc, item) => acc + (item.amountDue || 0), 0)
          )}`;
        }
        return "";
      },
      getGroupedCriteria: filters.groupBy
        ? (item) => {
            if (filters.groupBy === "invoicedDate") {
              return formatDate(item.invoicedDate, "DD MMMM YYYY") || "";
            }
            if (filters.groupBy === "billToAccountId") {
              return item.billToAccountId || "";
            }
            return "";
          }
        : undefined,
    },
  };
}
